// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","img":"flI4N_","AniFadeIn":"D_l2ex","AniFadeOut":"_1_exRK","AniRotate":"bq7zAc","AniPlaceholderFadeOut":"e6fKJh"};